<template lang="html">
  <section class="customer-domains">
    <base-card :no-padding="true">
      <template v-slot:header>
        <card-header>
          <template v-slot:actions>
            <button class="m-button outline-brand" @click.stop="toggleModal">
              {{ $t("newCustomerDomain") }}
            </button>
          </template>
        </card-header>
      </template>
      <table class="m-table bordered no-row-hover">
        <thead>
          <tr>
            <th>{{ $t("domainName") }}</th>
            <th>{{ $t("access") }}</th>
          </tr>
        </thead>
        <tbody v-if="isSetupReady">
          <customer-domain-row
            v-for="(customer, index) in customerList"
            :key="index"
            :id="`customer-domain-${customer.uuid}`"
            :customer="customer"
          />
        </tbody>
      </table>
    </base-card>
    <customer-domain-modal
      v-if="displayModal"
      :id="`create-customer-domain-${$route.params.uuid}`"
      :uuid="$route.params.uuid"
      :modal-title="$t('newCustomerDomain')"
      :uuid-add-new="uuidAddNew"
      @on-add-modal-close="toggleModal"
    />
    <transition name="loader">
      <div class="loader-wrapper" v-if="displayLoader">
        <div class="loader"></div>
      </div>
    </transition>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";
  import { MUTATION_NAME } from "@/static/global-variables";
  import BaseCard from "@/components/card/BaseCard";
  import CardHeader from "@/components/card/CardHeader";
  import { TOAST_OPTIONS } from "@/static/global-variables";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import CustomerDomainRow from "@/components/custom-display-elements/tabs/customer-domains/CustomerDomainRow";
  import CustomerDomainModal from "@/components/custom-display-elements/modal/CustomerDomainModal";

  export default  {
    name: "customer-domains",
    components: {
      BaseCard,
      CardHeader,
      CustomerDomainRow,
      CustomerDomainModal
    },
    data () {
      return {
        displayLoader: false,
        displayModal: false,
        customerDomainWidgetAccess: {},
        isSetupReady: false,
        uuidAddNew: uuidv4(),
        customerList: []
      }
    },
    watch: {
      customerDomains: {
        handler() {
          this.customerList = [];
          this.$nextTick(() => {
            if(this.isCurrentStoreData) {
              this.customerList = JSON.parse(JSON.stringify(this.customerDomains.customers));
            }
          });
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      customerDomains() {
        return this.$store.getters[MUTATION_NAME.CUSTOMER_DOMAINS] || {};
      },
      isCurrentStoreData() {
        return this.customerDomains.uuid === this.$route.params.uuid;
      },
      distributionchannel() {
        return this.$store.getters[MUTATION_NAME.DISTRIBUTION_CHANNEL_LATEST_WIDGETS] || {};
      },
      widgets() {
        return this.isCurrentStoreData ? this.distributionchannel.widgets : [];
      }
    },
    mounted () {
      this.$store.commit(MUTATION_NAME.SETUP_CUSTOMER_DOMAIN_WIDGET_ACCESS, this.customerDomainWidgetAccess);
      this.isSetupReady = true;
      if(!this.isCurrentStoreData) {
        this.displayLoader = true;
        DistributionChannelsService.customerDomains(this.$route.params.uuid)
        .catch((e) => {
          this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        })
        .finally(() => {
          this.displayLoader = false;
          this.getWidgetList();
        });
      }
    },
    methods: {
      toggleModal() {
        this.displayModal = !this.displayModal;
      },
      getWidgetList() {
        if(this.isCurrentStoreData && !this.widgets) {
          this.displayLoader = true;
          DistributionChannelsService.distributionChannelLatestWidgets(this.$route.params.uuid)
          .catch((e) => {
            this.$bvToast.toast(this.getMessageText(this.messages.ERROR_WHILE_LOADING), TOAST_OPTIONS.bottomCenter);
            console.error(e);
          })
          .finally(() => {
            this.displayLoader = false;
          });
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .customer-domains {
    box-sizing: border-box;
    padding: 1rem;
  }
</style>
